import { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface CanvasShellProps {
  children: ReactNode;
  className?: string;
}

/**
 * The morphing canvas. One container, many faces.
 * Animated swap is handled by callers via key + animate-fade-in.
 */
export function CanvasShell({ children, className }: CanvasShellProps) {
  return (
    <div className={cn("flex min-h-[calc(100vh-4rem)] w-full flex-col bg-background", className)}>
      <div className="flex-1 animate-fade-in">{children}</div>
    </div>
  );
}
